import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type {RootState} from "../../stores";
import {closeDialog} from "../../stores/dialog.slice.ts";
import _ from "lodash";

let resolveCallback: ((value: boolean) => void) | null = null;

export const SetResolveCallback = (resolve: (value: boolean) => void) => {
  resolveCallback = resolve;
};

const Dialog: React.FC = () => {
  const dispatch = useDispatch();
  const { isOpen, type, title, message } = useSelector((state: RootState) => state.dialog);

  // 확인 버튼 핸들러
  const handleConfirm = () => {
    if (resolveCallback) {
      resolveCallback(true); // Promise를 true로 해결
    }
    dispatch(closeDialog());
  };

  // 취소 버튼 핸들러
  const handleCancel = () => {
    if (resolveCallback) {
      resolveCallback(false); // Promise를 false로 해결
    }
    dispatch(closeDialog());
  };

  if (!isOpen) return null;

  return (
    <div className="alert">
      <div className="dropdown-layer">
        {!_.isEmpty(title) && (
          <h3>{title}</h3>
        )}
        <div className="text">
          {message}
        </div>
        <ul className={`btn-wrap ${type === 'alert' ? 'single' : ''}`}>
          <li className="confirm"><a onClick={handleConfirm}>확인</a></li>
          {type === 'confirm' && (
            <li className="cancel"><a onClick={handleCancel}>취소</a></li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Dialog;